import { Heading } from 'components/Heading';
import {
  CheckMarkLinear,
  InfoIcon,
  OpenIcon,
  ShapeIcon,
  ToolTipIcon,
} from 'components/Icons';

import * as S from './styles';

import { useContext, useEffect, useMemo, useState } from 'react';
import { api } from 'services/api';
import { Loading } from 'components/Loading';
import moment from 'moment';
import 'moment/locale/pt-br';
import { MainHeader } from 'components/MainHeader';
import { BaseMain } from 'components/BaseMain';

import SubHeader from 'components/SubHeader/SubHeader';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { BaseContentMain } from 'components/BaseContentMain';
import { ClientInfoContext } from 'contexts/ClientInfoContext';

import { EyeShow, PeopleSearch } from 'styled-icons/fluentui-system-regular';
import { BoxContent } from 'components/BoxContent';
import { DataDetails } from 'components/DataDetails';
import Button from 'components/Button';
import { Banner } from 'components/Banner';
import { ToolTip } from 'components/ToolTip';

// import { PeopleSearch } from 'styled-icons/fluentui-system-filled';
export const formatCurrency = (value: number) => {
  try {
    if (Number.isNaN(Number(value))) {
      throw new Error('Invalid money value');
    }
    const formatMoney = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
    return formatMoney.format(value).replace(/\s/, ' ');
  } catch (e: any) {
    return e.message;
  }
};
export type DataProps = {
  totalCost: string;
  discountValue: string;
  installmentAmount: number;
  totalUserCount: number;
  maxUserCount: number;
  frequency: string;
  startTrialDate: string;
  activationDate: string;
  terminationDate: string;
  id_client: string;
  name: string;
  typeProduct: string;
  totalLeasingContractCount: string;
  finalValue: string;
};

export type PlanDetailsProps = {
  activationDate: string;
  totalUserCount: number;
  maxUserCount: number;
  totalUserExtra: number;
  costUserExtra: number | undefined;
  totalCostUserExtra: number | undefined;
  frequency: string;
  startTrialDate: string;
  terminationDate: string;
  name: string;
  id_plan: number;
  id_client: string;
  plan: {
    name: string;
  };
  status: string;
  typeProduct: string;
  totalLeasingContractCount: string;
};

export type PlanDetailsValuesProps = {
  activationDate: string;
  terminationDate: string;
  additionalUserCost: string;
  frequency: string;
  totalCost: string;
  discountValue: string;
  finalValue: string;
  installmentAmount: number;
  installmentValue: string;
  status: string;
  typeProduct: string;
  type_payment: {
    description: string;
  };
};

export const KenloIntelligence = () => {
  const [indicatorsPerPage, setIindicatorsPerPage] = useState(3);
  const [isMobile, setIsMobile] = useState(false);
  const imobUrl = process.env.REACT_APP_URL_IMOB;

  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const history = useCustomUtilsHistory();
  const { dataClientInfo } = useContext(ClientInfoContext);
  const [dataHistory, setDataHistory] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inforToBanner, setInforToBanner] = useState<any>();

  // const imobId = localStorage.getItem('company_id');
  const [indicators, setIndicators] = useState<any>();

  const [totalInfos, setTotalInfos] = useState<number>(0);
  const [inforSignature, setInforSignature] = useState<any>({});
  const [newPlan, setNewPlan] = useState<any>();
  const [loadingNewPlan, setLoadingNewPlan] = useState(false);
  const showMoreIndicators = () => {
    setIindicatorsPerPage((indicatorsPerPage) => indicatorsPerPage + 3);
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const [inforImob, setInforImob] = useState<any>();

  useEffect(() => {
    const fetchDataSignatures = async () => {
      try {
        const { data } = await api.get(
          `client/billings/signature/${inforImob?.id_signature}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setInforToBanner(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    inforImob?.id_signature && fetchDataSignatures();
  }, [accessToken, idToken, inforImob?.id_signature]);
  useEffect(() => {
    const fetchDataInfors = async () => {
      try {
        const { data } = await api.get(
          `external-products/inteligence/${inforImob?.id_signature}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setIndicators(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    inforImob?.id_signature && fetchDataInfors();
  }, [accessToken, idToken, inforImob?.id_signature]);

  function capitalize(str: any): string {
    if (typeof str === 'string') {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
      return '';
    }
  }
  useEffect(() => {
    const fetchComplementaryProducts = async () => {
      setIsLoading(true);
      try {
        const { data } = await api.get('products', {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        setInforImob(data.data.find((el: any) => el.id === 6));
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    };
    fetchComplementaryProducts();
  }, [accessToken, idToken]);
  useEffect(() => {
    const fetchDataSignatures = async () => {
      try {
        const { data } = await api.get(
          `client/signatures/${inforImob?.id_signature}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setInforSignature(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    inforImob?.id_signature && fetchDataSignatures();
  }, [accessToken, idToken, inforImob?.id_signature]);
  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const { data } = await api.get(
          `/external-products/inteligence/${dataClientInfo?.id_realstate}/user-history?page=1&limit=${indicatorsPerPage}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        dataClientInfo?.id_realstate &&
          setDataHistory(
            data.data.map((el: any) => ({
              ...el,
              mes: moment(el.reference_date).month() + 1,
              ano: moment(el.reference_date).format('YYYY'),
              namePlano: el.product.name,
              valueExplorer: el.qty_explorer_users,
              valueVizualization: el.qty_reader_users,
            })),
          );
        setTotalInfos(data.pagination.total);
      } catch (error) {
        console.log(error);
      }
    };
    dataClientInfo?.id_realstate && fetchHistory();
  }, [accessToken, idToken, dataClientInfo?.id_realstate, indicatorsPerPage]);
  const percentage = useMemo(() => {
    if (!indicators?.qty_max_reader_users) return 100;
    if (dataHistory[0]?.valueVizualization) {
      return (
        (dataHistory[0].valueVizualization * 100) /
        indicators?.qty_max_reader_users
      );
    }

    return 0;
  }, [dataHistory, indicators?.qty_max_reader_users]);

  useEffect(() => {
    const fetchNewPlan = async () => {
      setLoadingNewPlan(true);
      try {
        const { data } = await api.get(
          `/external-products/inteligence/ideal/${dataHistory[0]?.valueVizualization}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setNewPlan(data.data);
      } catch (error) {
        console.log(error);
      }
      setLoadingNewPlan(false);
    };
    dataHistory[0]?.exceeded_quota && fetchNewPlan();
  }, [accessToken, idToken, dataHistory]);
  const disableButtonVerMaisIndicators = dataHistory.length >= totalInfos;

  return (
    <>
      <MainHeader />
      <SubHeader
        title="Detalhes do Produto"
        onReturn={() => history.push('/ClientArea')}
      />
      {isLoading && <Loading />}
      <BaseMain hideHeader>
        {dataHistory[0]?.exceeded_quota && !loadingNewPlan ? (
          <S.WrapperBanner>
            <Banner
              icon={<InfoIcon />}
              text={`O número de usuários ativos na imobiliária ultrapassou o limite de licenças disponíveis. Seu plano será atualizado para o<b> ${
                newPlan?.name
              } </b> em ${
                3 - Number(dataHistory[0]?.consecutive_exceedances) >= 1
                  ? 3 - Number(dataHistory[0]?.consecutive_exceedances)
                  : ''
              } ${
                3 - Number(dataHistory[0]?.consecutive_exceedances) < 1
                  ? 'breve.'
                  : `${
                      3 - Number(dataHistory[0]?.consecutive_exceedances) > 1
                        ? 'meses'
                        : 'mês'
                    }.`
              }`}
            >
              <a
                href="https://mkt.blog.kenlo.com.br/kenlo-inteligencia"
                target="_blank"
                rel="noopener noreferrer"
              >
                Saiba mais
              </a>
            </Banner>
          </S.WrapperBanner>
        ) : (
          <></>
        )}
        {inforToBanner && (
          <>
            {moment(inforToBanner.dueDate).isBefore(
              moment.tz(new Date(), 'America/Sao_Paulo').subtract(10, 'days'),
            ) ? (
              <S.WrapperBanner>
                <Banner
                  icon={<InfoIcon color="#6C2B22" />}
                  style={{
                    display: 'flex',
                    backgroundColor: '#FAE3E0',
                    color: '#6C2B22',
                    justifyContent: 'space-between',
                  }}
                  text={`Última fatura pendente! Para evitar o cancelamento da sua assinatura, realize o pagamento o quanto antes.`}
                />
              </S.WrapperBanner>
            ) : (
              <S.WrapperBanner>
                <Banner
                  icon={<InfoIcon />}
                  text={`Última fatura pendente! Entre em contato com o suporte em caso de problemas com o boleto.`}
                />
              </S.WrapperBanner>
            )}
          </>
        )}
        <S.BodyContentWrapper>
          <S.WrapperAside>
            <S.contentAside>
              <S.TitleAside>
                <span className="title">Kenlo Inteligência</span>
                <InvoiceStatus
                  status={inforImob?.status === 'ativo' ? 'paga' : 'cancelada'}
                  text={inforImob?.status === 'ativo' ? 'Ativo' : 'Suspenso'}
                />
              </S.TitleAside>
              <S.TitleAside>
                <S.TextAside color="#404040">Licenças visualizador</S.TextAside>
                <span className="title">
                  {!indicators?.qty_max_reader_users
                    ? `${indicators?.qty_min_reader_users}+`
                    : indicators?.qty_max_reader_users || 0}
                </span>
              </S.TitleAside>
              {indicators?.qty_max_explorer_users > 0 && (
                <S.TitleAside>
                  <S.TextAside color="#404040">Licenças explorador</S.TextAside>
                  <span className="title">
                    {indicators?.qty_max_explorer_users ||
                      indicators?.qty_min_explorer_users ||
                      0}
                  </span>
                </S.TitleAside>
              )}

              <hr
                style={{
                  marginLeft: '-24px',
                  marginRight: '-24px',
                  marginBottom: '24px',
                }}
              />
              <S.TitleAside>
                <S.TextAside fontWeight="700">Cobrança</S.TextAside>
              </S.TitleAside>
              <S.Grid>
                <div>
                  <S.TextAside fontSize="12" color="#808080">
                    Data de contratação
                  </S.TextAside>
                  <S.TextAside>
                    {moment(inforImob?.activationDate).format('DD/MM/YYYY')}
                  </S.TextAside>
                </div>{' '}
                <div>
                  <S.TextAside fontSize="12" color="#808080">
                    Data de renovação
                  </S.TextAside>
                  <S.TextAside>
                    {moment(inforSignature?.terminationDate)
                      .startOf('month')
                      .format('D[º] [de] MMMM [de] YYYY')}
                  </S.TextAside>
                </div>
              </S.Grid>

              <div>
                <S.TextAside fontSize="12" color="#808080">
                  Valor
                </S.TextAside>
                <S.TextAside fontSize="20">
                  {formatCurrency(inforImob?.installmentValue || 0) || '0,00'} /
                  {inforImob?.planFrequency === 'mensal' ? 'mês' : 'ano'}
                </S.TextAside>
              </div>
            </S.contentAside>
          </S.WrapperAside>
          <S.WrapperMain>
            <S.contentAside>
              <S.TitleAside>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <S.Circle
                    percentage={`${percentage > 100 ? 100 : percentage}`}
                    color={percentage > 100 ? '#DA9227' : '#004D70'}
                  >
                    {percentage > 100 && <ShapeIcon />}
                    {percentage === 100 && (
                      <CheckMarkLinear
                        stopColor="#004D70"
                        stopColorOffset="#298EE6"
                      />
                    )}
                  </S.Circle>

                  <div>
                    <S.TextAside fontSize="32" fontWeight="700">
                      {dataHistory[0]?.valueVizualization || 0} usuários
                    </S.TextAside>
                    <S.TextAside
                      fontSize="16"
                      color="#808080"
                      style={{ marginTop: '8px' }}
                    >
                      visualizadores
                    </S.TextAside>
                  </div>
                </div>
                {!isMobile && (
                  <S.TextAside
                    fontSize="16"
                    color="#298ee6"
                    fontWeight="700"
                    cursor
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                    onClick={() =>
                      window.open(
                        `${imobUrl}/admin/default.aspx#/relatorios`,
                        '_blank',
                      )
                    }
                  >
                    <OpenIcon color="#298ee6" />
                    Gerenciar
                  </S.TextAside>
                )}
              </S.TitleAside>
              <hr style={{ margin: ' 0 -24px ' }} />
              <S.GridInfos>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                  }}
                >
                  <EyeShow size={24} strokeWidth={2} color={'#004D70'} />
                  <div>
                    <S.TextCustom
                      fontSize="16"
                      fontWeight="500"
                      color=" #404040"
                    >
                      Os visualizadores verão relatórios diferentes conforme o
                      nível de permissionamento do perfil.
                    </S.TextCustom>
                  </div>
                </div>
              </S.GridInfos>
              {indicators?.qty_max_explorer_users > 0 && (
                <S.GridInfos>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    {' '}
                    <PeopleSearch size={24} strokeWidth={2} color={'#004D70'} />
                    <div>
                      <S.TextCustom
                        fontSize="16"
                        fontWeight="500"
                        color=" #404040"
                      >
                        Os exploradores podem criar novos relatórios com os
                        dados da imobiliária.
                      </S.TextCustom>
                    </div>
                  </div>
                </S.GridInfos>
              )}
            </S.contentAside>
            <BaseContentMain
              padding="2.4rem 2.4rem 2.4rem 2.4rem"
              title={
                <S.WrapperTitle>
                  <Heading
                    title="Histórico"
                    weight="600"
                    size="large"
                    color="#1A1A1A"
                  />
                  <ToolTip
                    right="2rem"
                    height="3rem"
                    content="Os valores histórico sempre considera o pico de usuários no mês por cada tipo de licença."
                    icon={
                      <div>
                        <ToolTipIcon />
                      </div>
                    }
                  />
                </S.WrapperTitle>
              }
            >
              <>
                {dataHistory.map((indicator) => (
                  <BoxContent
                    key={`${indicator.mes}-${indicator.ano}`}
                    style={{
                      display: 'flex',
                      padding: '1.6rem 2.4rem 1.6rem 2.4rem',
                      alignItems: 'center',
                    }}
                    color="#E5E5E5"
                  >
                    <DataDetails
                      title={`${
                        indicator.mes === moment().month() + 1
                          ? 'Este mês'
                          : capitalize(
                              `${moment(
                                `${indicator.ano}-${indicator.mes}-01`,
                                ['YYYY-M-DD', 'YYYY-MM-DD'],
                              ).format('MMMM')} de ${indicator.ano}`,
                            )
                      }`}
                      subtitle={indicator.product.name}
                    />
                    <S.ContentCard>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        {' '}
                        <EyeShow size={24} strokeWidth={2} color={'#004D70'} />
                        <div>
                          <S.TextCustom
                            fontSize="16"
                            fontWeight="500"
                            color={
                              indicator.valueVizualization > 0
                                ? ' #1A1A1A'
                                : ' #E5E5E5'
                            }
                          >
                            {indicator.valueVizualization}{' '}
                            {!isMobile ? 'visualizadores' : ''}
                          </S.TextCustom>
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px ',
                        }}
                      >
                        {' '}
                        <PeopleSearch
                          size={24}
                          strokeWidth={2}
                          color={'#004D70'}
                        />
                        <div>
                          <S.TextCustom
                            fontSize="16"
                            fontWeight="500"
                            color={
                              indicator.valueExplorer > 0
                                ? ' #1A1A1A'
                                : ' #E5E5E5'
                            }
                          >
                            {indicator.valueExplorer}{' '}
                            {!isMobile ? 'exploradores' : ''}
                          </S.TextCustom>
                        </div>
                      </div>
                    </S.ContentCard>
                  </BoxContent>
                ))}

                <S.BoxMoreHistory>
                  <Button
                    onClick={showMoreIndicators}
                    disabled={disableButtonVerMaisIndicators}
                  >
                    Ver mais
                  </Button>
                </S.BoxMoreHistory>
              </>
            </BaseContentMain>
          </S.WrapperMain>
        </S.BodyContentWrapper>
      </BaseMain>
    </>
  );
};
